import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { MxAlertService, MxBaseRestService } from 'mx-commons';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NotificationPopup } from 'src/app/model/notificationPopUp';
import { blobToFile, getErrorMessageHttp, isNotNullAndUndefined, isNullOrUndefined } from 'src/app/shared/helpers/utils';
import { ModalService, StatusResultModalEdit } from 'src/app/shared/services/modal.service';
import { LoginService } from '../../login/login.service';
import { ModalChangePermissionComponent } from '../change-permission/modal-change-permission.component';
import { ModalNotificationComponent } from '../modal-notification/modal-notification.component';
import { ModalUserAlterPasswordComponent } from '../user-alterpassword/modal-user-alterpassword.component';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

	mostrarMenu = false;
	nome: string;
	usuario: any;
	pushRightClass: string;

	imgUser: SafeResourceUrl = null;
	imageBase64: string = null;
	isLoading = false;
	notifications: Array<NotificationPopup> = Array<NotificationPopup>();
	notificationsCount: number = 0;
	notificationPosition: number = 0;

	@ViewChild('file', { static: false }) file;
	colorCode: string = sessionStorage.getItem("colorMain")

	constructor(
		public readonly router: Router,
		private readonly authService: LoginService,
		private readonly alertService: MxAlertService,
		private readonly sanitizer: DomSanitizer,
		private readonly restService: MxBaseRestService,
		private readonly bsModalService: BsModalService,
		private readonly modalService: ModalService,
		private readonly ng2ImgMax: Ng2ImgMaxService,
	) {

		this.router.events.subscribe(val => {
			if (val instanceof NavigationEnd && window.innerWidth <= 992 && this.isToggled()) {
				this.toggleSidebar();
			}
		});

	}

	async ngOnInit() {
		await this.loadNotifications()
		this.pushRightClass = 'push-right';
		if (this.authService.usuario) {
			this.usuario = this.authService.usuario;
			this.nome = this.usuario.name;
			this.loadImagemUser();
		} else {
			this.authService.onUserChange.subscribe((usr: any) => {
				this.usuario = usr;
				this.nome = this.usuario.name;
				this.loadImagemUser();
			});
		}
		this.openModalNotification(this.notifications[this.notificationPosition], this.notificationPosition)
	}

	async loadNotifications(): Promise<void> {
		this.authService.usuario.id
		const result = await this.restService.getter(`popup-notification-user/${this.authService.usuario.id}`, '', '').toPromise();
		this.notifications = result.docs;
		this.notificationsCount = result.total;
	}

	openModalNotification(notification: NotificationPopup, position: number) {
		if(notification) {
			const notify = {
				notification: notification,
				index: position,
				isOpen: true
			}
			this.modalService.show<ModalNotification>(ModalNotificationComponent, notify, this.resultSuccessModalNotification.bind(this));
		}
	}

	private async resultSuccessModalNotification(resultData: ModalNotification, status: StatusResultModalEdit): Promise<void> {
		if (status === StatusResultModalEdit.SAVE && isNotNullAndUndefined(resultData)) {
			await this.restService.put(`popup-notification-user/${resultData.notification.id}`, '', '', '').toPromise();
			if(this.notifications && this.notifications[resultData.index + 1] && this.notifications[resultData.index].isRead && !resultData.isOpen) {
				this.openModalNotification(this.notifications[resultData.index + 1], resultData.index + 1);
			}
		}
	}

	isToggled(): boolean {
		const dom: Element = document.querySelector('body');
		return dom.classList.contains(this.pushRightClass);
	}

	toggleSidebar() {
		const dom: any = document.querySelector('body');
		dom.classList.toggle(this.pushRightClass);
	}

	rltAndLtr() {
		const dom: any = document.querySelector('body');
		dom.classList.toggle('rtl');
	}

	async onImageUserAdd(): Promise<void> {
		this.file.nativeElement.click();
	}

	onImageUserChange(file: File) {
		if (isNullOrUndefined(file)) {
			return;
		}

		const pattern = 'image-*/';
		if (!file.type.match(pattern)) {
			this.alertService.error('Formata do imagem inválida');
			this.file.nativeElement.value = null;
			return;
		}

		this.ng2ImgMax.resizeImage(file, 100, 100).subscribe(result => {
			const img = blobToFile(result, result.name);
			const reader = new FileReader();
			reader.onload = this._handleReaderLoaded.bind(this);
			reader.readAsDataURL(img);
			this.file.nativeElement.value = null;
		}, error => {
			this.alertService.error(`Ops, não foi possível carregar a imagem. ${error.reason}`);
			console.log('😢 Oh no!', error.reason);
		});
	}

	private async _handleReaderLoaded(e): Promise<void> {
		const reader = e.target;
		this.imageBase64 = reader.result;

		this.isLoading = true;
		const objToSave = { id: this.authService.usuario.id, base64: this.imageBase64 };
		try {
			await this.restService.post('files', 'imageBase64', objToSave).toPromise();

		} catch (erro) {
			this.alertService.error(getErrorMessageHttp(erro));
		} finally {
			this.isLoading = false;
		}

		this.alertService.success('Imagem do usuário alterada com sucesso!');
		this.loadImagemUser(this.imageBase64);
	}

	private loadImagemUser(base64?: string): void {
		if (isNotNullAndUndefined(base64)) {
			this.imgUser = this.sanitizer.bypassSecurityTrustResourceUrl(base64);
		} else {
			this.restService.getter('files', `imageBase64/${this.authService.usuario.id}`, '').subscribe(data => {
				if (isNotNullAndUndefined(data)) {
					this.imgUser = data.base64;
				}
			}, error => {
				//
			});
		}
	}

	openAlterPassword(): void {
		const modalOption = new ModalOptions();
		modalOption.class = `modal-sm`;
		modalOption.backdrop = 'static';
		modalOption.keyboard = false;
		modalOption.initialState = {};
		this.bsModalService.show(ModalUserAlterPasswordComponent, modalOption);
	}

	openChangePermission(): void {
		const modalOption = new ModalOptions();
		modalOption.class = `modal-md`;
		modalOption.backdrop = 'static';
		modalOption.keyboard = false;
		modalOption.initialState = {};
		this.bsModalService.show(ModalChangePermissionComponent, modalOption);
	}

}

export interface ModalNotification {
	notification: NotificationPopup;
	index: number;
	isOpen: boolean;
}
